import React, { Component } from 'react'
import { observer } from 'mobx-react'
import Main from 'components/Home/Main'
import Aside from 'components/Home/Aside'
import styles from './index.css'
import config from 'config'

@observer(['cardTableStore'])
export default class Home extends Component {
  componentDidMount () {
    const { cardTableStore } = this.props
    const examinationId = config.EXAM_MAP[this.props.params.exam]

    if (!cardTableStore.subjects.length &&
        !cardTableStore.types.length &&
        !cardTableStore.categories.length &&
        !cardTableStore.cards.length) {
      cardTableStore.resetData(examinationId)
    }
  }

  render () {
    const examinationId = config.EXAM_MAP[this.props.params.exam]

    return (
      <div className={ styles.root }>
        <Main examinationId={ examinationId } />
        <Aside />
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/pages/Home/index.js
 **/